import React, { useEffect, useState } from "react";
import axios from "axios";
import { backend_url } from "../App";
import "./CSS/varietyAccessories.css";
import { ToastContainer, toast } from "react-toastify";
import { isAdmin } from "../utils/roleUtils";
import "react-toastify/dist/ReactToastify.css";

const PromoCodes = () => {
    const [items, setItems] = useState([]);
    const [formData, setFormData] = useState({
        promoCode: "",
        discount: "",
        startDate: "",
        endDate: "",
    });
    const [showConfirm, setShowConfirm] = useState(false);
    const [sendConfirm, setSendConfirm] = useState(null);
    const [sendingId, setSendingId] = useState(null);
    const [selectedItemId, setSelectedItemId] = useState(null);
    const [editingId, setEditingId] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 10;

    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = items.slice(indexOfFirstItem, indexOfLastItem);

    const totalPages = Math.ceil(items.length / itemsPerPage);


    useEffect(() => {
        fetchItems();
    }, []);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };


    const fetchItems = async () => {
        try {
            const response = await axios.get(`${backend_url}/api/getpromocode`);
            setItems(response.data);
        } catch (error) {
            toast.error("Error fetching items:", error.response?.data?.error || error.message);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!formData.promoCode || !formData.discount) {
            toast.error("PromoCode and Discount are required");
            return;
        }

        if (formData.startDate && formData.endDate && formData.endDate < formData.startDate) {
            toast.error("Expiry date cannot be before start date");
            return;
        }

        try {
            await axios.post(`${backend_url}/api/createpromocode`, formData, {
                headers: {
                    "Content-Type": "application/json"
                }
            });
            toast.success("Code Added Successfully");
            fetchItems();
            closeModal();
        } catch (error) {
            toast.error("Error saving item: " + (error.response?.data?.error || error.message));
        }
    };


    const handleDelete = (id) => {
        setSelectedItemId(id);
        setShowConfirm(true);
    };

    const confirmDelete = async () => {
        try {
            await axios.delete(`${backend_url}/api/deletepromocode/${selectedItemId}`);
            toast.success("Code deleted successfully");
            fetchItems();
        } catch (error) {
            toast.error("Error deleting item:", error.response?.data?.error || error.message);
        } finally {
            setShowConfirm(false);
        }
    };

    const confirmSendEmail = async () => {
        const item = sendConfirm;
        setSendConfirm(null);
        setSendingId(item._id);
        try {
            const res = await axios.post(`${backend_url}/api/sendpromoemail`, { promoId: item._id });
            toast.success(`Offer email sent to ${res.data.sentTo} customer(s)`);
        } catch (error) {
            toast.error("Failed to send: " + (error.response?.data?.message || error.message));
        } finally {
            setSendingId(null);
        }
    };

    const closeModal = () => {
        setShowModal(false);
        setEditingId(null);
        setFormData({ promoCode: "", discount: "", startDate: "", endDate: "" });
    };

    /* ── validity helpers ── */
    const getPromoStatus = (item) => {
        const now = new Date();
        if (item.startDate && now < new Date(item.startDate)) return "scheduled";
        if (item.endDate) {
            const expiry = new Date(item.endDate);
            expiry.setHours(23, 59, 59, 999);
            if (now > expiry) return "expired";
        }
        return "active";
    };

    const fmtDate = (d) =>
        d ? new Date(d).toLocaleDateString("en-IN", { day: "numeric", month: "short", year: "numeric" }) : null;

    const validityLabel = (item) => {
        const from = fmtDate(item.startDate);
        const to   = fmtDate(item.endDate);
        if (from && to) return `${from} – ${to}`;
        if (to)         return `Until ${to}`;
        if (from)       return `From ${from}`;
        return "No expiry";
    };
    return (
        <div className="variety-admin">
            <div className="headerSections">
                <div className="head-title">PromoCode</div>
                <button className="add-btn" onClick={() => setShowModal(true)}>
                    + Add PromoCode
                </button>
            </div>

            {showModal && (
                <div className="pcm-overlay" onClick={closeModal}>
                    <div className="pcm-modal" onClick={(e) => e.stopPropagation()}>
                        <div className="pcm-header">
                            <div>
                                <h2 className="pcm-title">&#127991; New Promo Code</h2>
                                <p className="pcm-subtitle">Create a discount code for your customers</p>
                            </div>
                            <button type="button" className="pcm-close" onClick={closeModal}>&times;</button>
                        </div>
                        <form onSubmit={handleSubmit} className="pcm-form">
                            <div className="pcm-field">
                                <label htmlFor="promoCode">Promo Code</label>
                                <input
                                    className="pcm-input pcm-code-input"
                                    type="text"
                                    id="promoCode"
                                    name="promoCode"
                                    placeholder="e.g. AUGUST20"
                                    value={formData.promoCode}
                                    onChange={(e) => setFormData({ ...formData, promoCode: e.target.value.toUpperCase() })}
                                    maxLength={10}
                                    required
                                />
                                <span className="pcm-hint">Customers enter this at checkout · max 10 characters</span>
                            </div>
                            <div className="pcm-field">
                                <label htmlFor="discount">Discount</label>
                                <div className="pcm-input-affix">
                                    <input
                                        className="pcm-input"
                                        type="number"
                                        id="discount"
                                        name="discount"
                                        placeholder="10"
                                        value={formData.discount}
                                        onChange={handleInputChange}
                                        min={1}
                                        max={100}
                                        required
                                    />
                                    <span className="pcm-affix">%</span>
                                </div>
                            </div>
                            <div className="pcm-row">
                                <div className="pcm-field">
                                    <label htmlFor="startDate">Starts <span className="pcm-optional">optional</span></label>
                                    <input
                                        className="pcm-input"
                                        type="date"
                                        id="startDate"
                                        name="startDate"
                                        value={formData.startDate}
                                        onChange={handleInputChange}
                                    />
                                </div>
                                <div className="pcm-field">
                                    <label htmlFor="endDate">Expires <span className="pcm-optional">optional</span></label>
                                    <input
                                        className="pcm-input"
                                        type="date"
                                        id="endDate"
                                        name="endDate"
                                        value={formData.endDate}
                                        onChange={handleInputChange}
                                        min={formData.startDate || undefined}
                                    />
                                </div>
                            </div>
                            <span className="pcm-hint">Leave dates empty for a code that never expires.</span>
                            <div className="pcm-actions">
                                <button type="button" onClick={closeModal} className="pcm-cancel-btn">
                                    Cancel
                                </button>
                                <button type="submit" className="pcm-submit-btn">
                                    {editingId ? "Update Code" : "Create Code"}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            )}

            <table className="variety-table">
                <thead>
                    <tr>
                        <th>Promocode</th>
                        <th>Discount</th>
                        <th>Validity</th>
                        <th>Status</th>
                        <th>Actions</th>
                    </tr>
                </thead>
                <tbody>
                    {currentItems.map((item) => {
                        const status = getPromoStatus(item);
                        return (
                        <tr key={item._id} className={status === "expired" ? "promo-row-expired" : ""}>
                            <td>
                                {item.promoCode}
                            </td>
                            <td>
                                {item.discount}%
                            </td>
                            <td>
                                {validityLabel(item)}
                            </td>
                            <td>
                                <span className={`promo-status-badge promo-status-${status}`}>
                                    {status === "active" ? "Active" : status === "scheduled" ? "Scheduled" : "Expired"}
                                </span>
                            </td>
                            <td>
                                {/* <button onClick={() => handleEdit(item)}>Edit</button> */}
                                {isAdmin() && (
                                    <button
                                        className="promo-send-btn"
                                        disabled={status === "expired" || sendingId === item._id}
                                        title={status === "expired" ? "Expired codes cannot be sent" : "Email this offer to all customers"}
                                        onClick={() => setSendConfirm(item)}
                                    >
                                        {sendingId === item._id ? "Sending…" : "📣 Send Offer"}
                                    </button>
                                )}
                                {isAdmin() && <button onClick={() => handleDelete(item._id)}>Delete</button>}
                            </td>
                        </tr>
                        );
                    })}
                </tbody>
            </table>
            {totalPages > 1 && (
                <div className="pagination-controls">
                    <button
                        onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
                        disabled={currentPage === 1}
                    >
                        Prev
                    </button>
                    {Array.from({ length: totalPages }, (_, i) => i + 1).map((pageNum) => (
                        <button
                            key={pageNum}
                            onClick={() => setCurrentPage(pageNum)}
                            className={currentPage === pageNum ? "active" : ""}
                        >
                            {pageNum}
                        </button>
                    ))}
                    <button
                        onClick={() => setCurrentPage((prev) => Math.min(prev + 1, totalPages))}
                        disabled={currentPage === totalPages}
                    >
                        Next
                    </button>
                </div>
            )}
            {sendConfirm && (
                <div className="confirm-popup">
                    <div className="confirm-content">
                        <p>
                            Send <strong>{sendConfirm.promoCode}</strong> ({sendConfirm.discount}% off) offer
                            email to <strong>all registered customers</strong>?
                        </p>
                        <div className="popup-actions">
                            <button onClick={confirmSendEmail} className="confirm-btn">
                                Send
                            </button>
                            <button onClick={() => setSendConfirm(null)} className="cancel-btn">
                                Cancel
                            </button>
                        </div>
                    </div>
                </div>
            )}
            {showConfirm && (
                <div className="confirm-popup">
                    <div className="confirm-content">
                        <p>Are you sure you want to delete this Code?</p>
                        <div className="popup-actions">
                            <button onClick={confirmDelete} className="confirm-btn">
                                Confirm
                            </button>
                            <button onClick={() => setShowConfirm(false)} className="cancel-btn">
                                Cancel
                            </button>
                        </div>
                    </div>
                </div>
            )}

            <ToastContainer />
        </div>
    );
};

export default PromoCodes;
